import {
    Box,
    Button,
    CircularProgress,
    Container,
    Grid,
    Typography
} from '@mui/material';
import { useAppContext } from 'app/AppContext';
import { format } from 'date-fns';
import { fetchArray } from 'entity';
import Rodada from 'entity/Rodada';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { robustShare } from 'utils/shareUtils';
import CardRodada from '../CardRodada';

const formatDate = (dateStr) => format(new Date(dateStr), "dd/MM, HH:mm");

const ListaRodadas = ({ rodadas }) => {
    const navigate = useNavigate();

    const inscreverSe = (rodada) => {
        // navigate(`/public-inscricao?rodada=${rodada.uid}&type=2`);
        navigate(`/inscrever-se?rodada=${rodada.uid}`);
    };
    const fazerContato = (rodada) => {
        // Exemplo WhatsApp com texto pré-definido
        const whatsappNumber = rodada?.telefoneContato;
        const message = encodeURIComponent(`Olá, quero mais informações sobre a rodada "${rodada.nome}"`);
        window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
    };
    const compartilharRodada = async (rodada) => {
        const linkInscricao = `${window.location.origin}/inscrever-se?rodada=${rodada.uid}`;
        // const linkInscricao = `https://paeco-linkme.web.app/#/inscrever-se?rodada=${rodada.uid}`;

        let texto = `🎯 *${rodada.nome.toUpperCase()}*

${rodada.descricao}

📍 Local: ${rodada.local}
📅 Data: ${formatDate(rodada.dataInicio)} até ${formatDate(rodada.dataFinal)}

🔗 Link para inscrição: 
${linkInscricao}

💼 Participe desta oportunidade de negócios!`;

        // Adiciona contatos se disponíveis
        if (rodada.emailContato || rodada.telefoneContato) {
            texto += '\n\n📞 Contatos:';
            if (rodada.emailContato) {
                texto += `\n📧 Email: ${rodada.emailContato}`;
            }
            if (rodada.telefoneContato) {
                texto += `\n📱 WhatsApp: ${rodada.telefoneContato}`;
            }
        }

        // Usar o utilitário de compartilhamento robusto
        await robustShare({
            title: 'Rodada de Negócios',
            text: texto,
            url: linkInscricao,
            imageBase64: rodada.capa?.base64,
            imageName: `rodada-${rodada.nome}-capa.jpg`,
            askForImage: true,
            onSuccess: (method) => {
                console.log(`Compartilhamento bem-sucedido via ${method}`);
            },
            onError: (error, method) => {
                console.error(`Erro no compartilhamento via ${method}:`, error);
            }
        });
    };
    if (!rodadas.length) {
        return (
            <Box sx={{ px: { xs: 2, md: 4 }, py: 6 }}>
                <Typography variant="h5" color="text.secondary" textAlign="center">
                    Não há rodadas disponíveis no momento.
                </Typography>
            </Box>
        );
    }

    return (<Box sx={{ px: { xs: 0.5, md: 4 }, py: 4 }}>
        <Typography variant="h4" fontWeight={600} textAlign="center" gutterBottom sx={{ px: { xs: 2, md: 0 } }}>
            Próximas Rodadas
        </Typography>

        <Grid container spacing={{ xs: 1, md: 4 }} justifyContent="center">
            {rodadas.map((rodada, index) => (
                <Grid item xs={12} md={6} lg={6} key={index}>
                    <CardRodada
                        rodada={rodada}
                        onCompartilhar={compartilharRodada}
                    >
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => inscreverSe(rodada)}
                            aria-label={`Inscrever-se na rodada ${rodada.nome}`}
                            sx={{
                                minHeight: { xs: '44px', md: '48px' },
                                flex: 1,
                                fontSize: { xs: '0.875rem', md: '1rem' }
                            }}
                        >
                            Inscrever-se
                        </Button>
                        {rodada?.telefoneContato &&
                            <Button
                                variant="outlined"
                                fullWidth
                                color="success"
                                onClick={() => fazerContato(rodada)}
                                aria-label={`Entrar em contato via WhatsApp sobre a rodada ${rodada.nome}`}
                                sx={{
                                    minHeight: { xs: '44px', md: '48px' },
                                    flex: 1,
                                    fontSize: { xs: '0.875rem', md: '1rem' }
                                }}
                            >
                                Contato WhatsApp
                            </Button>}
                    </CardRodada >
                </Grid>
            ))}
        </Grid>
    </Box>
    );
};

export default function PublicRodadaList() {
    const [rodadas, setRodadas] = useState([]);
    const [loading, setLoading] = useState(true);
    const { useSetTitle } = useAppContext();

    useSetTitle('RODADA DE NEGÓCIOS');

    const loadOptions = useCallback(async () => {
        if (rodadas.length === 0) {
            const startData = new Date().toISOString().split('T')[0] + 'T00:00';
            let queryR = await Rodada.where('status', '==', 'ATIVO');
            queryR = queryR.where('rodadaPublica', '==', "SIM");
            queryR = queryR.where('dataFinal', '>=', startData);
            let resultRodada = await fetchArray(queryR.get());

            resultRodada.sort(
                (a, b) => new Date(a.dataInicio).getTime() - new Date(b.dataInicio).getTime()
            );

            setRodadas(resultRodada);
            setLoading(false);
        }
    }, [rodadas.length]);

    useEffect(() => {
        loadOptions();
    }, [loadOptions]);

    const rodadasFiltradas = rodadas.filter((r) => {
        const now = new Date();
        const inicio = new Date(r.dataInicio);
        const fim = new Date(r.dataFinal);
        return inicio > now || (inicio <= now && fim >= now);
    }); return (
        <Container maxWidth={false} sx={{ py: { xs: 2, md: 4 }, px: { xs: 0, md: 3 } }}>
            {loading ? (
                <Box textAlign="center">
                    <CircularProgress />
                </Box>
            ) : (
                <ListaRodadas rodadas={rodadasFiltradas} />
            )}
        </Container>
    );
}
